export default __webpack_public_path__ + "static/SectionTwo_02_02-b7edc5b231f9c35ecae6ab15402413cc.webp";